const Row = ({ r, bold, testId }) => {
  const d = r.delta_vs_prev ?? 0;
  return (
    <div className={`grid grid-cols-[1fr_auto_auto_auto_auto] gap-x-2 items-center text-[13px] ${bold ? "font-extrabold text-gray-600" : "font-semibold text-gray-500"}`}
         data-testid={testId}>
      <span className="truncate">{r.name}</span>
      <span className="text-right w-8">{r.target}</span>
      <span className="text-right w-8 text-gray-700">{r.projection}</span>
      <span className="text-right w-8" style={{ color: d >= 0 ? "#059669" : "#dc2626" }}>{d >= 0 ? "+" : ""}{d}</span>
      <span className="text-right w-14">{r.pct_of_target != null ? `${r.pct_of_target}%` : "—"}</span>
    </div>
  );
};

export const DealersLujoBlock = ({ dealers, week }) => (
  <div className="mt-3 p-2.5 rounded-md bg-gray-50" style={{ border: "1px dashed #cbd5e1" }}
       data-testid="dealers-lujo-block">
    <div className="text-[12px] font-extrabold uppercase tracking-wider text-gray-400 mb-1">
      Dealers Lujo · informativo
    </div>
    <div className="grid grid-cols-[1fr_auto_auto_auto_auto] gap-x-2 text-[11px] font-extrabold uppercase text-gray-400 mb-0.5">
      <span/><span className="text-right w-8">Obj</span><span className="text-right w-8">W{week || "?"}</span>
      <span className="text-right w-8">ΔW</span><span className="text-right w-14">%</span>
    </div>
    {dealers.rows.map((r) => <Row key={r.name} r={r} testId={`dealers-lujo-row-${r.name.toLowerCase()}`}/>)}
    {dealers.rows.length > 1 && (
      <div className="mt-1 pt-1" style={{ borderTop: "1px dashed #e2e8f0" }}>
        <Row r={dealers.total} bold testId="dealers-lujo-total"/>
      </div>
    )}
    <div className="text-[11px] text-gray-400 mt-1">No suma al total de la división ni de las marcas.</div>
  </div>
);
